module.exports = __webpack_public_path__ + "static/media/tutorial-book.4bdcf5d6.png";